(function ($, Cobalt, undefined) {
    Cobalt.UserProfile = {
        initialize: function() {
            Cobalt.UserProfile.addCustomProfileValidation();

            $("#advanced-profile-form").on("submit", function () {
                return Cobalt.UserProfile.addCustomProfileValidation(true);
            });
        },
        addCustomProfileValidation: function (forceChange) {
            var hasErrors = false;
            $(".j-profile-field").each(function() {
                var $that = $(this);
                var $input = $that.find(":input");
                var $errorLabel = $that.find(".j-field-error-label");

                var label = $that.data("field-label");
                var inputType = $that.data("field-type");
                var jsonValidation = $that.data("field-validators");

                $input.on("change", function () {
                    var value = $input.val();
                    $errorLabel.text(""); //reset to no error
                    
                    if (value.length > 0) { //only validate if there is a value
                        switch (jsonValidation.PrimaryValidator) {
                            case 1:
                                //numeric
                                {
                                    //validate its a number
                                    if (!(!isNaN(parseFloat(value)) && isFinite(value))) {
                                        $errorLabel.text(label + " must be a number.");
                                    }

                                    if (jsonValidation.NumericMinimum !== null) {
                                        if (value < jsonValidation.NumericMinimum) {
                                            $errorLabel.text(label + " must be at least " + jsonValidation.NumericMinimum);
                                        }
                                    }

                                    if (jsonValidation.NumericMaximum !== null) {
                                        if (value > jsonValidation.NumericMaximum) {
                                            $errorLabel.text(label + " must be less than " + jsonValidation.NumericMaximum);
                                        }
                                    }
                                    break;
                                }
                            case 2:
                                //text
                                {
                                    if (jsonValidation.StringMinLength !== null) {
                                        if (value.length < jsonValidation.StringMinLength) {
                                            $errorLabel.text(label + " must be at least " + jsonValidation.StringMinLength + " characters.");
                                        }
                                    }
                                    if (jsonValidation.StringMaxLength !== null) {
                                        if (value.length > jsonValidation.StringMaxLength) {
                                            $errorLabel.text(label + " must be less than " + jsonValidation.StringMaxLength + " characters.");
                                        }
                                    }
                                    break;
                                }
                            case 3:
                                //url
                                {
                                    var urlRegex = new RegExp("^(http[s]?:\/\/(www\.)?|ftp:\/\/(www\.)?|www\.){1}([0-9A-Za-z-\.@:%_\+~#=]+)+((‌​\.[a-zA-Z]{2,3})+)(\/(.)*)?(\?(.)*)?", "g");
                                    if (!urlRegex.test(value)) {
                                        $errorLabel.text(label + " must be a URL.");
                                    }
                                    break;
                                }
                            case 4:
                                //regex
                                {
                                    var regex = new RegExp(jsonValidation.RegularExpression, "g");
                                    if (!regex.test(value)) {
                                        $errorLabel.text(label + " failed validation.");
                                    }
                                    break;
                                }
                        };
                    }
                    });


                if (forceChange) {
                    $input.change();
                    if ($errorLabel.text().length > 0) {
                        hasErrors = true;
                    }
                }
            });
            return !hasErrors;
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.UserProfile.js